<div class="modal-header" id="material-return-p58-modal-title">
    <h3
        class="modal-title"
        id="modal-title"
        [translate]="
            isBootstockReturn
                ? 'BOOTSTOCK_RETURN_TITLE'
                : isBootstockScrap
                  ? 'BOOTSTOCK_SCRAP_TITLE'
                  : 'MATERIAL_RETURN_TITLE'
        "
    ></h3>
    <span class="close" (click)="!isLoading && closeModal()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="materialReturnForm">
        @if (model.materialReturnList.length > 0 && !isBootstockScrap) {
            <fieldset>
                <div class="row mb-3">
                    <label
                        class="col-md-2 col-12 col-form-label text-start"
                        translate="MATERIAL_RETURN_SEARCH_WITH_AWB_LABEL"
                    ></label>
                    <div class="col-md-10 col-12">
                        <pace-core-text-input
                            id="txtAwbReturn"
                            [(model)]="model.awbReturn"
                            [parentForm]="materialReturnChildren"
                            (valueChange)="selectMaterial()"
                            [ariaLabel]="'MATERIAL_RETURN_SEARCH_WITH_AWB_LABEL' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            </fieldset>
        }
        <div class="row">
            <div class="col-12" [ngClass]="{ 'col-lg-6': !isBootstockScrap }">
                <fieldset
                    class="mb-3 w-100"
                    [ngClass]="{
                        'col-md-5': displayAdditionalMaterialReturnInformation,
                        'col-md-4': !displayAdditionalMaterialReturnInformation,
                    }"
                >
                    <div class="container-fluid">
                        <div class="row p-2 border-bottom text-center table-header fw-bold">
                            <div
                                class="col-3 d-flex gap-2 align-items-center"
                                [ngClass]="{ 'offset-2': !isBootstockScrap }"
                                (click)="setOrderBy('materialIdentifier.materialNumber.value')"
                            >
                                @if (!displayAdditionalMaterialReturnInformation) {
                                    <span translate="MATERIAL_RETURN_MATERIAL_NUMBER_LABEL"></span>
                                    <span translate="MATERIAL_RETURN_DESCRIPTION_LABEL"></span>
                                }
                                @if (displayAdditionalMaterialReturnInformation) {
                                    <span class="fw-bold" translate="MATERIAL_RETURN_MATERIAL_COLUMN_LABEL"></span>
                                }
                                @if (orderBy === 'materialIdentifier.materialNumber.value') {
                                    <span class="sort-order" [ngClass]="{ reverse: reverse }"></span>
                                }
                            </div>
                            @if (displayAdditionalMaterialReturnInformation) {
                                <div
                                    class="col-4 d-flex gap-2 align-items-center"
                                    (click)="setOrderBy('notificationIdentifier.qmNum')"
                                >
                                    <span class="fw-bold" translate="MATERIAL_RETURN_NOTIFICATION_COLUMN_LABEL"></span>
                                    @if (orderBy === 'notificationIdentifier.qmNum') {
                                        <span class="sort-order" [ngClass]="{ reverse: reverse }"></span>
                                    }
                                </div>
                            }
                            <div class="col-3 d-flex gap-2 align-items-center" (click)="setOrderBy('quantity.value')">
                                <span class="fw-bold" translate="MATERIAL_RETURN_QUANTITY_LABEL"></span>
                                @if (orderBy === 'quantity.value') {
                                    <span class="sort-order" [ngClass]="{ reverse: reverse }"></span>
                                }
                            </div>
                        </div>

                        @for (
                            materialReturn of model.materialReturnList | orderBy: orderBy : reverse;
                            track materialReturn;
                            let last = $last
                        ) {
                            <div class="row p-2">
                                @if (!isBootstockScrap) {
                                    <div class="col-2 p-0">
                                        <pace-core-checkbox-input
                                            [parentForm]="materialReturnChildren"
                                            [(model)]="materialReturn.material.isRowSelected"
                                            (valueChange)="onMaterialSelectionChange(materialReturn)"
                                        >
                                        </pace-core-checkbox-input>
                                    </div>
                                }
                                <div class="col-3 d-flex flex-column text-break">
                                    {{ materialReturn.material.materialIdentifier.materialNumber.value }}
                                    @if (
                                        displayAdditionalMaterialReturnInformation &&
                                        materialReturn.selectedPartSet.orderNumber.value
                                    ) {
                                        <br />({{ materialReturn.selectedPartSet.orderNumber.value }} |
                                        {{ materialReturn.selectedPartSet.orderPosition.value }})
                                    }
                                    @if (materialReturn.material.description.value) {
                                        <br />{{ materialReturn.material.description.value }}
                                    }
                                    @if (
                                        displayAdditionalMaterialReturnInformation &&
                                        materialReturn.selectedPartSet.awb.value
                                    ) {
                                        <br />({{ materialReturn.selectedPartSet.awb.value }})
                                    }
                                </div>
                                @if (
                                    materialReturn.material.isBootstockMaterial &&
                                    materialReturn.material.isBootstockReturn
                                ) {
                                    <div class="col-4 d-flex flex-column">
                                        <span translate="BOOTSTOCK_RETURN_TITLE"></span>
                                    </div>
                                } @else if (
                                    materialReturn.material.isBootstockMaterial &&
                                    materialReturn.material.isBootStockScrapable
                                ) {
                                    <div class="col-4 d-flex flex-column">
                                        <span translate="BOOTSTOCK_SCRAP_TITLE"></span>
                                    </div>
                                } @else {
                                    @if (displayAdditionalMaterialReturnInformation) {
                                        <div class="col-4 d-flex flex-column text-break">
                                            {{ materialReturn.material.notificationIdentifier.qmNum }}
                                            @if (materialReturn.material.notificationIdentifier.maNum) {
                                                <br />({{ materialReturn.material.notificationIdentifier.maNum }})
                                            }
                                            @if (materialReturn.customerAddress.name1) {
                                                <br />{{ materialReturn.customerAddress.name1.value }}
                                            }
                                        </div>
                                    }
                                }
                                <div class="col-3 d-flex flex-column text-break">
                                    {{
                                        materialReturn.material.isBootstockMaterial &&
                                        (materialReturn.material.isBootstockReturn ||
                                            materialReturn.material.isBootStockScrapable)
                                            ? materialReturn.material.deliveredQuantity
                                            : materialReturn.material.quantity.value
                                    }}
                                    @if (materialReturn.material.deliveryReturnSelectedOption === customerAddress) {
                                        <fa-icon [icon]="faUsers" class="ms-1"></fa-icon>
                                    }
                                    @if (materialReturn.material.deliveryReturnSelectedOption === dopAddress) {
                                        <fa-icon [icon]="faBuilding" class="ms-1"></fa-icon>
                                    }
                                    @if (materialReturn.material.deliveryReturnSelectedOption === taxiAddress) {
                                        <fa-icon [icon]="faTaxi" class="ms-1"></fa-icon>
                                    }
                                    @if (materialReturn.material.deliveryReturnSelectedOption === fedexAddress) {
                                        <fa-icon [icon]="faShippingFast" class="ms-1"></fa-icon>
                                    }
                                </div>
                                @if (
                                    materialReturn.material.isBootstockMaterial &&
                                    (materialReturn.material.isBootstockReturn ||
                                        materialReturn.material.isBootStockScrapable)
                                ) {
                                    <div class="col-12">
                                        <div class="row mb-3 mt-3">
                                            <label
                                                class="col-md-2 col-lg-3 col-12 col-form-label text-start pt-md-0"
                                                translate="BOOTSTOCK_RETURN_QUANTITY_LABEL"
                                            ></label>
                                            <div class="col-md-10 col-lg-9 col-12">
                                                <pace-core-number-stepper
                                                    [parentForm]="materialReturnChildren"
                                                    [(model)]="materialReturn.selectedPartSet.quantity"
                                                    name="quantity"
                                                    [ariaLabel]="
                                                        'CONFIRMATION_MATERIAL_STOCK_QUANTITY_ARIA_LABEL' | translate
                                                    "
                                                ></pace-core-number-stepper>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <label
                                                class="col-md-2 col-lg-3 col-12 col-form-label text-start"
                                                translate="BOOTSTOCK_RETURN_AWB_LABEL"
                                            ></label>
                                            @if (model.awbReturnLabel) {
                                                <div class="col-md-10 col-lg-9 col-12">
                                                    <pace-core-text-input
                                                        id="txtAwb"
                                                        [(model)]="model.awbReturnLabel"
                                                        [parentForm]="materialReturnChildren"
                                                        [ariaLabel]="'BOOTSTOCK_RETURN_AWB_LABEL' | translate"
                                                    ></pace-core-text-input>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </fieldset>
            </div>
            @if (!isBootstockScrap) {
                <hr class="col-sm-6 d-sm-none d-none w-100 my-2" />

                <div class="col-12 col-lg-6">
                    <div
                        [ngClass]="{
                            'col-md-12 col-12': displayAdditionalMaterialReturnInformation,
                            'col-md-8 col-12': !displayAdditionalMaterialReturnInformation,
                        }"
                    >
                        <fieldset class="mb-3">
                            <div class="container-fluid">
                                @if (model.materialReturnList.length > 0) {
                                    <div class="material-details">
                                        <pace-material-return-p58-detail
                                            [model]="model"
                                            [materialReturnChildren]="materialReturnChildren"
                                            (formValidated)="validateForm()"
                                            (addressOptionChanged)="onAddressOptionChanged()"
                                            [hidePhysicalReturn]="isBootstockReturn"
                                        >
                                        </pace-material-return-p58-detail>
                                    </div>
                                }
                            </div>
                        </fieldset>
                    </div>
                </div>
            }
        </div>
    </form>
</div>
<div class="modal-footer">
    @if (isLoading) {
        <progressbar type="default" [value]="100">
            {{ 'MATERIAL_RETURN_LOADING_MESSAGE' | translate }}
        </progressbar>
    } @else if (isBootstockScrap) {
        <button
            class="btn btn-primary mx-2"
            type="button"
            translate="BOOTSTOCK_SCRAP_BUTTON_LABEL"
            [disabled]="!isMaterialReturnValid()"
            (click)="sendReturn()"
        ></button>
        <button
            class="btn btn-secondary"
            type="button"
            translate="MATERIAL_RETURN_CANCEL_LABEL"
            (click)="closeModal()"
        ></button>
    } @else {
        @if (byBoxKonnectLink.length > 0) {
            <div class="me-lg-auto flex-grow-1 flex-lg-grow-0 d-none d-lg-block" paceCoreLink>
                <a class="btn btn-primary pace-link w-100" href="{{ byBoxKonnectLink }}" target="_blank"
                    >ByBox Konnect</a
                >
            </div>
        }
        <!-- Visible only on small screens -->
        <div class="me-lg-auto flex-grow-1 flex-lg-grow-0 d-lg-none" paceCoreLink>
            <button
                class="btn btn-primary w-100"
                type="button"
                [disabled]="!isMaterialPreparedForReturn() || !isMaterialReturnValid() || disableSendReturn"
                translate="MATERIAL_RETURN_SEND_RETURN_LABEL"
                (click)="sendReturn()"
            ></button>
        </div>

        <div class="d-lg-block d-none">
            <button
                class="btn btn-secondary mx-2"
                type="button"
                translate="MATERIAL_RETURN_RESET_DEFAULT"
                [disabled]="!isMaterialPreparedForReturn()"
                (click)="resetMaterialReturn()"
            ></button>
            <button
                class="btn btn-primary"
                type="button"
                translate="MATERIAL_RETURN_SAVE_LABEL"
                [disabled]="!isMaterialReturnValid()"
                (click)="saveMaterialReturn()"
            ></button>
            <button
                class="btn btn-primary mx-2"
                type="button"
                [disabled]="!isMaterialPreparedForReturn() || !isMaterialReturnValid() || disableSendReturn"
                translate="MATERIAL_RETURN_SEND_RETURN_LABEL"
                (click)="sendReturn()"
            ></button>
            <button
                class="btn btn-secondary"
                type="button"
                translate="MATERIAL_RETURN_CANCEL_LABEL"
                (click)="closeModal()"
            ></button>
        </div>

        <div class="btn-group d-lg-none menu-container" dropdown [dropup]="true">
            <button
                id="button-toggler"
                dropdownToggle
                type="button"
                class="btn btn-secondary more-toggler"
                aria-controls="dropdown-toggler"
                [attr.aria-label]="'MATERIAL_RETURN_ACTION_DROPDOWN_ARIA_LABEL' | translate"
            >
                <fa-icon [icon]="faEllipsisV"></fa-icon>
            </button>
            <ul
                id="dropdown-toggler"
                *dropdownMenu
                class="dropdown-menu dropdown-menu-right w-100"
                role="menu"
                aria-labelledby="button-toggler"
            >
                <!-- Small screen: Show ByBox Konnect in menu -->
                @if (byBoxKonnectLink.length > 0) {
                    <li role="menuitem">
                        <a
                            class="btn btn-outline-secondary btn-lg w-100 text-primary link-primary text-decoration-underline"
                            href="{{ byBoxKonnectLink }}"
                            target="_blank"
                        >
                            ByBox Konnect
                        </a>
                    </li>
                }

                <li role="menuitem">
                    <button
                        class="btn btn-secondary btn-lg w-100"
                        type="button"
                        translate="MATERIAL_RETURN_RESET_DEFAULT"
                        [disabled]="!isMaterialPreparedForReturn()"
                        (click)="resetMaterialReturn()"
                    ></button>
                </li>

                <li role="menuitem">
                    <button
                        class="btn btn-secondary save-material btn-lg w-100"
                        type="button"
                        translate="MATERIAL_RETURN_SAVE_LABEL"
                        [disabled]="!isMaterialReturnValid()"
                        (click)="saveMaterialReturn()"
                    ></button>
                </li>

                <li role="menuitem">
                    <button
                        class="btn btn-secondary btn-lg w-100"
                        type="button"
                        translate="MATERIAL_RETURN_CANCEL_LABEL"
                        (click)="closeModal()"
                    ></button>
                </li>
            </ul>
        </div>
    }
</div>
